import { render } from "./IconTwitter.vue?vue&type=template&id=74e9eda5&scoped=true&ts=true"
import script from "./IconTwitter.vue?vue&type=script&lang=ts"
export * from "./IconTwitter.vue?vue&type=script&lang=ts"

import "./IconTwitter.vue?vue&type=style&index=0&id=74e9eda5&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e9eda5"]])

export default __exports__